import type {
  HubProject,
} from '@robovision/hub'
import { capitalize } from 'lodash-es'
import { Datapool } from '../datapool/Datapool'


export enum ProjectTypes {
  MultiViewClassifier = 'Multi View Classifier',
}


export interface ProjectParams {
  algorithmType?: string
  createdAt: Date
  datapools: Datapool[]
  defaultAlgorithmId?: string
  defaultAlgorithmVersion?: string
  description: string
  id: string
  metadata: Record<string, string>
  name: string
}

export class Project {
  static readonly modelName = 'Project'

  public readonly algorithmType?: string
  public readonly createdAt: Date
  public readonly datapools: Datapool[] | readonly Datapool[]
  public readonly defaultAlgorithmId?: string
  public readonly defaultAlgorithmVersion?: string
  public readonly description: string
  public readonly id: string
  public readonly metadata: Record<string, string>
  public readonly name: string

  public constructor (params: ProjectParams) {
    this.algorithmType = params.algorithmType
    this.createdAt = params.createdAt
    this.datapools = params.datapools
    this.defaultAlgorithmId = params.defaultAlgorithmId
    this.defaultAlgorithmVersion = params.defaultAlgorithmVersion
    this.description = params.description
    this.id = params.id
    this.metadata = params.metadata
    this.name = params.name

    Object.freeze(this)
  }

  public get normalizedType (): ProjectTypes | string {
    const type = this.algorithmType ?? this.defaultAlgorithmId ?? ''
    const normalized = (type
      .split('.')
      .at(-1) ?? '')
      .split(/(?=[A-Z])/)
      .join(' ')

    return capitalize(normalized)
  }

  public static fromResponse (data: HubProject) {
    return new Project({
      algorithmType: data.algorithmType,
      createdAt: new Date(data.createdAt),
      datapools: data.datapools.map(Datapool.fromResponse),
      defaultAlgorithmId: data.defaultAlgorithmId,
      defaultAlgorithmVersion: data.defaultAlgorithmVersion,
      description: data.description,
      id: data.id,
      metadata: data.metadata || {},
      name: data.name,
    })
  }
}
